import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { BLOCKS } from "@contentful/rich-text-types";
import { Link } from 'gatsby';
import Img from "gatsby-image";
import React, { Fragment } from 'react';
import './benefits.scss';

const Benefits = props => {

    const { haveRetails, paramRetails } = props;

    const handleClickShowModal = () => {
        if(haveRetails && paramRetails.length > 1){
            props.setModalVisibility(true)
        }else if(haveRetails && paramRetails.length === 1){
            window.open(paramRetails[0].redireccionRetail,'_blank');
        }
    }
    
    return (
        <div className="f-benefits" >
            <h2 className="f-benefits-head f-h1" >{props.dataTitle}</h2>
            <div className="f-benefits-content" >
                <ul>
                    {props.data && props.data.map((feature, index) => 
                    <li key={index} className={`f-icotext ${!feature.imagenDelSello && feature.descripcionDelSello.json.content[0].nodeType !== 'heading-5' && 'f-icotext f-icotext--text'}`}>
                        {feature.imagenDelSello && <img src={feature.imagenDelSello.file.url} alt={feature.imagenDelSello.description} />}
                        {documentToReactComponents(feature.descripcionDelSello.json)}
                    </li>)}
                </ul>
                {/* <div className="f-buttons" >
                    {props.buttons && props.buttons.map((value, index) => {
                       if(value){
                        if (value.shop) {
                            if(false !== haveRetails && paramRetails && paramRetails.length >= 1){
                                return (
                                    <button
                                        key={index}
                                        className={`f-buttons-button-${index}`}
                                        onClick={() => {
                                            handleClickShowModal()
                                        }}
                                        >
                                        {value.title}
                                        <div className="f-img-container">
                                            {value.icon &&
                                                // <Img fluid={value.icon} className="f-shop-logo"
                                                // alt={value.icon.description}  /> 
                                                <img
                                                    className="f-shop-logo"
                                                    src={value.icon}
                                                    alt={value.icon.description}
                                                />

                                            }
                                        </div>
                                    </button>
                                )
                            }else{
                                return null
                            }
                        } else {
                            return (                                
                                <Link
                                    key={index}
                                    className={`f-buttons-button-${index}`}
                                    to={value.slug}
                                    onClick={value.action}
                                >
                                    {value.title}
                                    <div className="f-img-container">
                                        {value.icon &&
                                            // <Img fluid={value.icon} className="f-shop-logo"
                                            // alt={value.icon.description}  /> 
                                            <img
                                                className="f-shop-logo"
                                                src={value.icon}
                                                alt={value.icon.description}
                                            />

                                        }
                                    </div>
                                </Link>
                            )
                        }
                       }
                    })}
                </div> */}
            </div>
            <div className="f-benefits-image" >
                {(props.image.src !== "" && props.image.title !== "") ?
                <Img fluid={props.image.src}  alt={props.image.title}  />
                :
                <></>
                }
                {/* <img src={props.image.src} alt={props.image.title} ></img> */}
            </div>
        </div>
    )
}

export default Benefits;